import { generalApiRequest } from "../../../api/apiIndex";

export default async function getElapsedMinutes(session_id) {
  const url = "getElapsedMinutes";
  const res = await generalApiRequest(
    url,
    "GET",
    { session_id: session_id },
    1
  );
  return res.elapsed_minutes;
}
